
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M11.93 23.44H58.5v10.47H7.16v-5.9M28.29 23.7l-9.96 9.95M47.33 23.7l-9.95 9.95"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M7.16 34.3v24.09H58.5V31.97M11.98 21.86l45.05-10.03-2.28-10.22L4.64 12.76l1.09 4.87M34.19 6.45L46.07 14M15.6 10.59l11.88 7.55"}}),_c('circle',{attrs:{"cx":"6.74","cy":"22.77","r":"5.24","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    